<template>
  <v-row class="ma-0" align="center" justify="center">
    <v-col align="center" style="font-size: 13px">
        <div style="display:flex;justify-content: center;">
          <p class="mb-4 attention-message" > 【注意】</p>
          <p class="mb-4 attention-message" style="margin-left: 5px; width: 580px;text-align: left;">
            国語の教科書題材を使った問題は,一部の題材しか登録されておりません。<br>
            ログイン後,トップページの右下に「国語教科書題材 問題登録一覧」がありますので,<br>
            事前にご確認ください。
          </p>
        </div>
        <div style="display:flex;justify-content: center;">
          <p class="mb-4" > 【注意】</p>
          <p class="mb-4" style="margin-left: 5px; width: 580px;text-align: left;">
            登録されている問題は，弊社発行教材［テスト］の同一問題となります。<br>
            各問題に出典が表示されていますので，ご要望に応じて，問題を差し替えてご使用ください
          </p>
        </div>
        <div style="display:flex;justify-content: center;">
          <p class="mb-4" > 【重要】</p>
          <p class="mb-4" style="margin-left: 5px; width: 580px;text-align: left;">
            令和５年度のご利用ありがとうございました。
            令和６年４月１日より，パスワードが令和６年度のものに変更になります。
            お手数ではございますが，令和６年度も引き続きご利用の先生におかれましては，
            再度アカウント登録の申請をお願いいたします。
            新しいパスワードは，順次，文書で通知させていただく予定ですが，
            お急ぎの場合は，弊社特約店までご連絡ください。
            なお，IDは変更なしですので，問題使用履歴もそのまま引き継がれます。
          </p>
        </div>
        <v-card class="signin-card pa-10 elevation-10">
          <div class="text-center">
            <img class="logo" src="@/assets/img/header_logo.png" alt="新学社">
          </div>
          <v-form ref="form" @submit.prevent>
            <v-card-text class="mt-12 text-center">
              <v-text-field
                label="Login ID"
                name="login"
                prepend-icon="mdi-account"
                type="text"
                v-model="login"
                :disabled="!isRecommendedEnvironment"
              ></v-text-field>

              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                :disabled="!isRecommendedEnvironment"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
            <!-- 推奨環境のみログイン可能 -->
            <template v-if="isRecommendedEnvironment">
              <v-btn
                rounded
                block
                color="secondary"
                class="signin-btn"
                @click="signIn"
                type="submit"
                :disabled="!activateSubmit"
              >
                Sign In
              </v-btn>
            </template>
            <template v-else>
              <p class="not-recommended__message">ご利用いただいているブラウザでは正しく動作しないため、WindowsはEdgeまたはChrome、MacはSafariをご利用ください</p>
            </template>
            </v-card-actions>
          </v-form>
        </v-card>

        <!-- 動作環境ページ --><br>
        ブラウザは、WindowsはEdgeまたはChrome、MacはSafariをご利用ください。<br>
        詳しい動作環境は
        <router-link
          class="mt-8 env-check__link"
          to="/env_check"
          target="_blank"
        >
          こちら
        </router-link>
        をご覧ください。

      </v-col>

      <!-- 社会・技術・家庭に関しては学年が合っているかを確認 -->
      <!-- https://combine.backlog.jp/view/SIN_DEV-303 -->
      <v-dialog
        v-model="isRequiredCheckGrade"
        persistent
        max-width="400px"
      >
        <v-card
          min-height="150px"
        >
          <v-toolbar
            class="title"
          >ログインするアカウントの学年確認</v-toolbar>

          <v-card-text class="px-5">
            <!-- 学年確認 -->
            <div class="py-3">
              <p class="mb-0">{{grade}}年のテスト作成で間違いないでしょうか。</p>
            </div>
          </v-card-text>

          <v-card-actions class="card-action">
            <template>
              <v-btn color="secondary" dark class="dialog-Button" @click="checkGrade(true)">はい</v-btn>
              <v-btn color="gray" class="dialog-Button" @click=checkGrade(false)>いいえ</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
</template>

<script>

export default {
  components: {
  },
  computed: {
    // ログインボタンの活性非活性化
    activateSubmit() {
      return this.login !== '' && this.password !== ''
    },
    // 推奨環境かどうか
    isRecommendedEnvironment() {
      const userAgent = window.navigator.userAgent.toLowerCase();

      if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
        // IE
        return false
      } else if(userAgent.indexOf('edge') != -1) {
        return true
      } else if(userAgent.indexOf('chrome') != -1) {
        return true
      } else if(userAgent.indexOf('safari') != -1) {
        return true
      } else if(userAgent.indexOf('firefox') != -1) {
        return false
      } else if(userAgent.indexOf('opera') != -1) {
        return false
      } else {
        return false
      }
    }
  },
  data () {
    return {
      login: '',
      password: '',
      showPassword: false,
      grade: '',
      isRequiredCheckGrade: false,
    }
  },
  async mounted() {
    // ログイン中であればログアウト処理
    if (this.$store.state.user.accessToken) {
      await this.$axios.delete('/api/v1/auth/sign_out')
    }
    // ログイン中と判断される値を初期化
    this.$store.commit('user/logout', {})
  },
  methods: {
    // ログインAPI実行処理
    async signIn() {
      const res = await this.$axios.post('/api/v1/auth/sign_in', {
        login: this.login,
        password: this.password,
      })
      this.$app.$refs.loading.open({message: 'ログイン中です'})
      // 成功時の処理

      // レスポンスヘッダーから認証情報を取得
      const auth = {
        accessToken: res.headers['access-token'],
        client:      res.headers['client'],
        uid:         res.headers['uid'],
        userId:      res.data.data.id
      }
      // 認証情報とログイン情報をstoreに格納
      this.$store.commit('user/login', auth)
      this.$store.commit('user/setRole', { role: res.data.data.type })
      this.$store.commit('user/setLastOperatedDate', { lastOperatedDate: new Date })
      this.$store.commit('user/setUserId', { userId: res.data.data.id })
      this.$store.commit('user/setIsDemo', { isDemo: res.data.data.is_demo })
      this.$store.commit('user/setRemainingDownloadCount', { remainingDownloadCount: res.data.data.remaining_download_count })
      // axiosのヘッダーにログイン情報設定
      const strageData = JSON.parse(sessionStorage.getItem('ShingakushaEpro'));
      this.$axios.defaults.headers.common['access-token'] = strageData.user.accessToken;
      this.$axios.defaults.headers.common['client']       = strageData.user.client;
      this.$axios.defaults.headers.common['uid']          = strageData.user.uid;
      // マスタデータ取得
      await this.$store.dispatch('master/getMasterData')

      // 先生アカウントの場合、所属学校データを取得（ナビバー表示用）
      if(this.$store.getters['user/isTeacher']) {
        const url = `api/v1/schools/${res.data.data.school_id}`
        const school = await this.$axios(url)
        this.$store.commit('user/setSchoolData', { schoolData: school.data })
        // 担当教科をリセット
        this.$store.commit('setSubjectTeachers', [])
      }

      // 社会・技術・家庭に関しては学年が合っているかを確認
      // https://combine.backlog.jp/view/SIN_DEV-303
      const regex = /(sh|gi|ka)([123])-.*$/;
      const match = this.login.match(regex);
      if (match) {
        this.grade = match[2]
        this.isRequiredCheckGrade = true
        this.$app.$refs.loading.close()
        return
      }

      // ログインアカウントによって遷移先を振り分ける（管理者・先生）
      this.$router.push(this.$store.getters['user/homePath'])
      this.$app.$refs.loading.close()
    },
    async checkGrade(result) {
      if (result) {
        this.$router.push(this.$store.getters['user/homePath'])
      } else {
        this.$toasted.global.error({ message: '該当学年のアカウントで再度ログインしてください。' })
        this.grade = ""
        this.isRequiredCheckGrade = false
        if (this.$store.state.user.accessToken) {
          await this.$axios.delete('/api/v1/auth/sign_out')
        }
        // ログイン中と判断される値を初期化
        this.$store.commit('user/logout', {})
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.row
  height 100%

.logo
  margin-right 18px

.signin
  &-card
    height 500px
    max-width 371px
    + tablet-horizontal()
        height 450px
        max-width 321px
    + tablet-vertical()
        height 450px
        max-width 301px

  &-btn
    color white !important
    margin-top 60px
  &-btn:enabled
    background-image linear-gradient(to bottom, #10318b, #55669b 30%, #2b3555)

.not-recommended__message
  color red

.attention-message
  color red
  font-size 14px

.attention_subject
  margin-right 110px

.message__area
  color: #f10;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 30px;
  text-decoration: underline;

.title
  justify-content center
  background-color: #2a5594 !important
  color white

.card-action
  justify-content space-around

.dialog-Button
  width 100px
  height 50px
</style>
